var timeout;

(function($) {
    $.validator.addMethod(
        "required-if-empty",
        function(value, element, param) {
            var otherValue = $(param).val();
            var result = value || otherValue;
            return result;
        },
        "Wypełnij pole"
    );
    $.validator.addMethod(
        "required-if-checked",
        function(value, element, param) {
            var other = $(param);
            var result = value || !other.is(":checked");
            return result;
        },
        "Wypełnij pole"
    );
    $.validator.addMethod(
        "myEmail",
        function(value, element) {
            value = value.toLowerCase();
            return (
                this.optional(element) ||
                (/^[a-z0-9]+([-._][a-z0-9]+)*@([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,250}$/.test(value) && /^(?=.{1,64}@.{4,64}$)(?=.{6,100}$).*/.test(value))
            );
        },
        "Proszę o podanie prawidłowego adresu email"
    );
    $.validator.addMethod(
        "nameValidator",
        function(value, element) {
            return this.optional(element) || /[a-z]/.test(value);
        },
        "To pole nie może zawierać samych wielkich liter i znaków specjalnych"
    );
    $.validator.addMethod(
        "myUrl",
        function(value, element) {
            if (!this.optional(element)) {
                if (value.indexOf("//") >= 0) {
                    value = value.split("//")[1];
                }

                value = value.split("/")[0];

                if (value.indexOf(".") < 0) {
                    return false;
                }

                value = value.split(".")[value.split(".").length - 1];

                return value.length >= 2;
            }
            return true;
        },
        "Proszę o podanie prawidłowego adresu www"
    );
    $.validator.addMethod(
        "securePassword",
        function(value) {
            return /[a-z]/g.test(value) && /[A-Z]/g.test(value);
        },
        "Hasło musi składać z conajmniej 1 wielkiej i 1 małej litery"
    );
})(jQuery);
